


























































































import Vue, { PropType } from 'vue';
import domtoimage from 'dom-to-image';
import { mapGetters } from 'vuex';
import pxButton from '@/dex-shared/components/px-button.vue';
import EssayReplyModel from '@/dex-shared/models/EssayReplyModel';
import { fileUploadURL } from '@/dex-shared/settings/endpoints';
import { TRACK_TYPES } from '@/dex-shared/helpers/track';

const smallActive = require('../assets/texts/text-small.svg');
const smallInactive = require('../assets/texts/text-small-inactive.svg');
const mediumActive = require('../assets/texts/text-medium.svg');
const mediumInactive = require('../assets/texts/text-medium.svg');
const bigActive = require('../assets/texts/text-big.svg');
const bigInactive = require('../assets/texts/text-big-inactive.svg');

const ARBITRARY_DRAFT_UPDATE_INTERVAL = 3000;

const TEXT_ACTIVATION_INTERVAL_START = 185;
const TEXT_ACTIVATION_INTERVAL_END = 187;

export default Vue.extend({
  components: {
    pxButton,
  },
  props: {
    essay: {
      type: Object as PropType<EssayReplyModel>,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      sending: false,
      oldDraft: '',
      essayMaxLength: 3600,
      textTrackCalled: false,
      style: {
        small: smallInactive,
        medium: mediumInactive,
        big: bigInactive,
        fontSize: 'font-size: 16px;',
      },
    };
  },
  computed: {
    buttonState() {
      if (this.userEssayCredits == 0) {
        return 'button-disabled';
      } else if (this.sending) {
        return 'loading-button';
      } else {
        return '';
      }
    },
    currentDraft: {
      set(currentDraft: string) {
        if (this.essay.id) {
          this.$store.commit('UPDATE_ENTITY', {
            entity: 'texts',
            data: {
              ...this.essay.textAnswer().raw(),
              body: currentDraft,
            },
          });
        }
      },
      get(): string {
        if (this.essay.textAnswer) {
          return this.essay.textAnswer().body;
        } else {
          return '';
        }
      },
    },
    ...mapGetters({
      userEssayCredits: 'userEssayCredits',
    }),
  },
  watch: {
    currentDraft(value: string) {
      let textLength = value.trim().length;
      if (
        !this.textTrackCalled &&
        textLength > TEXT_ACTIVATION_INTERVAL_START &&
        textLength < TEXT_ACTIVATION_INTERVAL_END
      ) {
        this.$track(TRACK_TYPES.ESSAY_STARTED, {
          discipline: 'redacao',
          essaySubject: this.essay.subject().slug,
          sentMethod: 'text',
        });
        this.$track(TRACK_TYPES.INTEGRATION_EVENT, {
          integration: 'imaginie',
          type: 'Essay Started',
        });
      }
    },
  },
  mounted() {
    let savedTextInput =
      (this.essay.textAnswer && this.essay.textAnswer().body) || '';
    if (savedTextInput.length >= TEXT_ACTIVATION_INTERVAL_START) {
      this.$track(TRACK_TYPES.ESSAY_CONTINUED, {
        discipline: 'redacao',
        essaySubject: this.essay.subject().slug,
        sentMethod: 'text',
      });
    }
    setInterval(this.updateDraft, ARBITRARY_DRAFT_UPDATE_INTERVAL);
  },
  methods: {
    async sendEssay() {
      if (this.userEssayCredits == 0) {
        return;
      }
      this.sending = true;
      const imageData = await this.convertTextToImage();
      const imageURL = await this.$store.dispatch('UPLOAD_IMAGE', imageData);
      try {
        await this.$store.dispatch('CREATE_AND_ASSOCIATE_IMAGE', {
          url: imageURL,
          essayId: this.essay.id,
        });
        await this.$store.dispatch('PUSH_ESSAY', this.essay.id);
        this.$track(TRACK_TYPES.ESSAY_CONSUMED, {
          discipline: 'redacao',
          essaySubject: this.essay.subject().slug,
          essayId: this.essay.id,
          sentMethod: 'text',
        });
        this.$track(TRACK_TYPES.INTEGRATION_EVENT, {
          integration: 'imaginie',
          type: 'Essay Sent',
        });
        this.sending = false;
      } catch (error) {
        this.$track(TRACK_TYPES.INTEGRATION_VIEWED, {
          integration: 'imaginie',
          type: 'Error',
          error_message: 'Essay by text could not be sent',
        });
        console.error('Essay by text could not be sent');
      }
    },
    updateDraft() {
      if (this.currentDraft && this.oldDraft != this.currentDraft) {
        this.oldDraft = this.currentDraft;
        const subjectSlug = this.$route.params.subjectSlug;
        const position = +this.$route.params.position - 1;
        this.$store.dispatch('UPDATE_DRAFT', { subjectSlug, position });
      }
    },
    convertTextToImage() {
      return domtoimage.toPng(this.$refs['essay-input']);
    },
    setStyle(size: string) {
      if (size == 'small') {
        this.style = {
          small: smallActive,
          medium: mediumInactive,
          big: bigInactive,
          fontSize: 'font-size: 14px;',
        };
      } else if (size == 'medium') {
        this.style = {
          small: smallInactive,
          medium: mediumActive,
          big: bigInactive,
          fontSize: 'font-size: 16px;',
        };
      } else if (size == 'big') {
        this.style = {
          small: smallInactive,
          medium: mediumInactive,
          big: bigActive,
          fontSize: 'font-size: 18px;',
        };
      }
    },
  },
});
